import React from "react";
import { observer } from "mobx-react-lite";
import { Button, Popover } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { ZUid } from "src/types/zUid";
import { EntityFiltersPageStore } from "../EntityFiltersPageStore";
import styles from "./AttsTree.module.less";

type PropsAttsTreeSelectedPath = {
  store: EntityFiltersPageStore;
  objectId: ZUid;
};

export const AttsTreeSelectedPath: React.FC<PropsAttsTreeSelectedPath> =
  observer(({ store }) => {
    const {
      attrsTreeStore,
      attrsTreeStore: { treeStdStore },
    } = store;

    const handleReset = async () => {
      const { restrictedNodeKey } = store;
      store.attrsTreeStore.setExpandedKeys([]);
      store.attrsTreeStore.setSelectedKeys(
        restrictedNodeKey ? [restrictedNodeKey] : [],
      );
      await store.saveEntitySearchState();
      store.reloadWithActualFilters();
    };

    // reverse without mutating cuz of mobx
    const list = [...attrsTreeStore.selectedKeys].reverse();
    const lastIndex = attrsTreeStore.selectedKeys.length - 1;
    const empty = list.length === 0;
    const path = list.map((item, index) => {
      const node = treeStdStore.findNode(item);
      const title =
        typeof node?.title === "function" ? node.title(node) : node?.title;
      const lastElement = index === lastIndex;
      return (
        <span key={item}>
          {title}
          {lastElement ? "" : "/"}
        </span>
      );
    });
    if (path.length === 0) return null;
    const selectedRestrictedNode =
      attrsTreeStore.selectedKeys.length === 1 &&
      store.isNodeKeyRestricted(
        attrsTreeStore.selectedKeys[0] as number | string,
      );
    return (
      <div className={styles.attsTreePathBox}>
        <Popover content={path} trigger="hover">
          <div className={styles.attsTreePathSection}>{path}</div>
        </Popover>
        {!empty && !selectedRestrictedNode && (
          <Button type="text" onClick={handleReset} icon={<CloseOutlined />} />
        )}
      </div>
    );
  });
